import styled from 'styled-components';

export const Container = styled.div`
  width:100%;
  background: var(--color-white);
  border-radius: 4px;

  display: flex;
  flex-direction: column;
  padding: 16px;

`;
